var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-order-detail',{staticClass:"pt-order-detail__page",attrs:{"id":_vm.id,"operation":_vm.operation}})}
var staticRenderFns = []

export { render, staticRenderFns }